import { ProductTypesEnum } from '../ProductInterface'
import { ReceiptPaymentType } from './ReceiptPaymentType'

export type Columns =
  | 'work'
  | 'description'
  | 'date'
  | 'quantity'
  | 'unit'
  | 'unitPrice'
  | 'discount'
  | 'vatPct'
  | 'taxTotal'
  | 'netTotal'
  | 'grossTotal'
  | 'discountPct'
  | 'total'
  | 'productType'

export interface PaymentScheduleFieldsInterface {
  paymentScheduleEnabled?: {
    name: 'paymentScheduleEnabled'
    visible?: boolean
    value: boolean
  }
}

export interface InvoiceNumberFieldInterface {
  name?: 'invoiceNumber'
  visible?: boolean
  value: string | null
}

export enum Locales {
  fi_FI = 'fi_FI',
  de_AT = 'de_AT',
  en_GB = 'en_GB',
  de_CH = 'de_CH',
  sv_FI = 'sv_FI',
  nl_BE = 'nl_BE',
  nl_NL = 'nl_NL',
  sv_SE = 'sv_SE',
  en_AU = 'en_AU',
  fr_CH = 'fr_CH',
  fr_BE = 'fr_BE',
  fr_FR = 'fr_FR',
  de_DE = 'de_DE',
}

export interface FieldsInterface extends PaymentScheduleFieldsInterface {
  additionalText?: {
    name?: 'additionalText'
    visible?: boolean
    value: string
  }
  locale?: {
    name: 'locale'
    visible?: boolean
    value: Locales
  }
  timeZone?: {
    name: 'timeZone'
    visible?: boolean
    value: string
  }
  currency: {
    name?: 'currency'
    visible?: boolean
    value: string
  }
  customer?: {
    name?: 'customer'
    visible?: boolean
    value: string
  }
  description?: {
    name?: 'description'
    visible?: boolean
    value: string
  }
  dueDate?: {
    name?: 'dueDate'
    visible?: boolean
    value: string
  }
  recipientReference?: {
    name?: 'recipientReference'
    visible?: boolean
    value: string
  }
  senderReference?: {
    name?: 'senderReference'
    visible?: boolean
    value: string
  }
  externalReference?: {
    name?: 'externalReference'
    visible?: boolean
    value: string
  }
  columns: {
    name?: 'columns'
    visible?: boolean
    value: Columns[]
  }
  interest?: {
    name?: 'interest'
    visible?: boolean
    value: number
  }
  invoiceNumber?: InvoiceNumberFieldInterface
  creditnoteNumber?: {
    name?: 'creditnoteNumber'
    visible?: boolean
    value: string
  }
  sender?: {
    name?: 'sender'
    visible?: boolean
    value: string
  }
  issueDate: {
    name?: 'issueDate'
    visible?: boolean
    value: string
  }
  language: {
    name?: 'language'
    visible?: boolean
    value: string
  }
  paymentTime?: {
    name?: 'paymentTime'
    visible?: boolean
    value: number
  }
  reductionPercentage?: {
    name?: 'reductionPercentage'
    visible?: boolean
    value: number
  }
  referenceNumber?: {
    name?: 'referenceNumber'
    visible?: boolean
    value: string
  }
  template: {
    name?: 'template'
    visible?: boolean
    value: string
  }
  footerText: {
    name?: 'footerText'
    visible?: boolean
    value: string
  }
  legalterms: {
    name?: 'legalterms'
    visible?: boolean
    value?: string
  }
  title?: {
    name?: 'title'
    visible?: boolean
    value: string
  }
  type: {
    name?: 'type'
    visible?: boolean
    value: number
  }
  typeName: {
    name?: 'typeName'
    visible?: boolean
    value: string
  }
  paymentMethod?: {
    name?: 'paymentMethod'
    visible?: boolean
    value: ReceiptPaymentType
  }
  discountEnabled: {
    name?: 'discountEnabled'
    visible?: boolean
    value: boolean
  }
  discountLocation: {
    name?: 'discountLocation'
    visible?: boolean
    value: 'perTotal' | 'perLine'
  }
  discountType?: {
    name?: 'discountType'
    visible?: boolean
    value: 'amount' | 'percentage'
  }
  discountVAT?: {
    name?: 'discountVAT'
    visible?: boolean
    value: 'preVAT' | 'postVAT'
  }
  exchangeRate?: {
    name?: 'exchangeRate'
    visible?: boolean
    value: number
  }
  deduction?: {
    name?: 'deduction'
    visible?: boolean
    value: number
  }
  recurringProfileEnabled?: {
    name: 'recurringProfileEnabled'
    visible?: boolean
    value: boolean
  }
  referenceFieldsOrder?: {
    name: 'referenceFieldsOrder'
    value: string
  }
  buyerReference?: {
    name: 'buyerReference'
    visible?: boolean
    value: string
  }
  paymentReferenceType?: {
    name: 'paymentReferenceType'
    value: paymentReferenceTypes.ISO | paymentReferenceTypes.SPY_BE | paymentReferenceTypes.SPY_FI
  }
  customerNumber?: {
    name: 'customerNumber'
    visible?: boolean
  }
  productType?: {
    name: 'productType'
    value: ProductTypesEnum
  }
}

export enum paymentReferenceTypes {
  ISO = 'ISO',
  SPY_FI = 'SPY_FI',
  SPY_BE = 'SPY_BE',
}

export interface DraftFieldsInterface extends FieldsInterface {
  discountAmount?: {
    name: 'discountAmount'
    visible?: boolean
    value: number
  }
  discount?: {
    name: 'discount'
    visible?: boolean
    value?: string
  }
  approvedInvoiceId?: {
    name: 'approvedInvoiceId'
    visible?: boolean
    value: number
  }
  approvedEstimateId?: {
    name: 'approvedEstimateId'
    visible?: boolean
    value: number
  }
}
